import { gql } from "graphql-tag";

const ALL_AGE_COVERAGE_FIELDS_FRAGMENT = gql`
  fragment AllAgeCoverageFields on AgeCoverage {
    fromAndIncludingAge
    toNotIncludingAge
    annualAmount
    lifelongPayout
    coverageTypeCode
    coverageName {
      norwegian
      english
    }
  }
`;

export const KEY_VALUES_FIELDS_FRAGMENT = gql`
  fragment KeyValuesFields on KeyValues {
    paidIn {
      value
    }
    totalReturn {
      value
    }
    marketValue {
      value
    }
  }
`;

export const ALL_HOLDING_FIELDS_FRAGMENT = gql`
  fragment AllHoldingFields on Holding {
    funds {
      isin
      name
      category
      totalReturnPct
      fundManagementFee
      actualDistribution
      marketValue {
        value
      }
    }
  }
`;

export const ALL_MANAGERS_FIELDS_FRAGMENT = gql`
  fragment AllManagersFields on Manager {
    firstName
    lastName
    managerRoleCode
    expirationDate
  }
`;

export const ALL_COVERAGES_FIELDS_FRAGMENT = gql`
  fragment AllCoveragesFields on Coverages {
    ageCoverages {
      ...AllAgeCoverageFields
    }
    conditionalAgeCoverages {
      ...AllAgeCoverageFields
    }
  }
  ${ALL_AGE_COVERAGE_FIELDS_FRAGMENT}
`;

export const LINK_FRAGMENT_FIELDS = `
  id
  productArea
  productNameFms {
    fmsKey
  }
  customerContractReference
  customerSuppliedContractName
  contractNumber
  productCode
  accountId
  participantId
  createdDate
  oneTimeDepositAccountNumber
  contractManagementFeePercentage
  administrationFee {
    label
    code
    fmsKey
  }
  allocationCode
  reductionFund {
    name
    isin
  }
  currentInvestmentProfile {
    investmentProfiles {
      isin
      name
      distributionPercentage
    }
    stockExposure
  }
  roles {
    name
    customerNumber
    participantId
    roleType
  }
  payout {
    fromDate
    endDate
    lifeLongPayout
  }
  managers {
    firstName
    lastName
    managerRoleCode
    expirationDate
  }
  contractNavigation {
    contractDetailsLink
    availableActions {
      actionType
      actionStatus
      actionNavigationLink
      supportExitUrl
    }
  }
  savingsAgreements {
    kid
    periodicAmount
    numberOfPeriodsAYear
    dayInMonth
  }
`;

export const LINK_CONTRACT_BENEFICIARY_FIELDS = `
    beneficiaries {
      firstName
      lastName
      coveragePercentage
      coverageTypeCode
    }
`;

export const LINK_CONTRACT_FIELDS_FRAGMENT = gql`
  fragment LinkContractFields on LinkContract {
    ${LINK_FRAGMENT_FIELDS}
    holdings {
      ...AllHoldingFields
    }
  }
  ${ALL_HOLDING_FIELDS_FRAGMENT}
`;

export const LINK_CONTRACT_BENEFICIARY_FRAGMENT = gql`
  fragment LinkContractBeneficiary on LinkContract {
      ${LINK_CONTRACT_BENEFICIARY_FIELDS}
  }
`;

export const ALIS_CONTRACT_FIELDS_FRAGMENT = gql`
  fragment AlisContractFields on AlisContract {
    id
    productNameFms {
      fmsKey
    }
    customerContractReference
    contractNumber
    balance
    premiumYearlyAmount
    activeContract
  }
`;

export const CONTRACT_NAVIGATION_FIELDS_FRAGMENT = gql`
  fragment ContractNavigationFields on ContractNavigation {
    contractDetailsLink
    availableActions {
      actionType
      actionStatus
      actionNavigationLink
      supportExitUrl
    }
  }
`;

export const EPK_OVERVIEW_FIELDS_FRAGMENT = gql`
  fragment EpkOverviewFields on EpkContract {
    id
    accountId
    contractNumber
    customerContractReference
    customerSuppliedContractName
    productNameFms {
      fmsKey
    }
    productArea
    productCode
    keyValues {
      ...KeyValuesFields
    }
  }
  ${KEY_VALUES_FIELDS_FRAGMENT}
`;
